import * as React from "react";

import { LabelStore } from "../flux/Label/LabelStore";
import { ListStore } from "../flux/Grid/ListStore";
import { FlagStore } from "../flux/Flag/FlagStore";
import { ErrorStore } from "../flux/Error/ErrorStore";
import { ValueStore } from "../flux/Value/ValueStore";

import { LoadDashboardCommand } from "../components/Pages/Home/commands/LoadDashboardCommand";
import { TakeOverSensorExcessCommand } from "../components/Pages/Home/commands/TakeOverSensorExcessCommand";
import { ShowSensorsDataCommand } from "../components/Pages/SensorsData/commands/ShowSensorsDataCommand";
import { FindIncidentDataCommand } from "../components/Pages/Home/commands/FindIncidentDataCommand";

import { Key, EntityType } from "../../models";
import { SearchFn } from "../../rest/Search";
import { GetSensorsDataForIncidentFn } from "../../rest/Geotab";
import { SensorExcess, ReportResult, DashboardFn, TakeOverSensorExcessFn } from "../../rest/Dashboard/interfaces";
import { Polyglot } from "../../polyglot";
import { Dashboard } from "../components/Pages/Home/Home2";
import { GoogleMapLoader } from "../utils/GoogleMapLoader";
import { SearchWithInitiatorCommand, getCurrentDivisionMiddleware } from "../components/Pages/commands/EntitySearchCommand";
import {SelectedItemsStore} from "../flux/Grid/SelectedItemsStore";
import {DeleteObjectsStore} from "../flux/DeleteObjects";
import {DeleteObjectsCommand} from "../components/Pages/commands/DeleteObjects";
import {DeleteObjectsFn} from "../../rest/DeleteObjects";

// This class is a configuration for Dashboard tab
// Constructor receives and/or creates dependencies and injects them
export class HomeTab
{
    private readonly homeReportTableTitleStore = new LabelStore();
    private readonly homeReportListStore = new ListStore<ReportResult>(r => null, "ReportExcessToken");
    private readonly homeSensorsExcessesListStore = new ListStore<SensorExcess>(se => se.IncidentId, EntityType.SensorExcess);
    private readonly homeTakeOverSensorExcessInProgressStore = new FlagStore();
    private readonly homeTakeOverSensorExcessErrorStore = new ErrorStore();
    private readonly homeExcessTableErrorStore = new ErrorStore();
    private readonly homeAlertStore = new FlagStore();
    private readonly homeVehicleSearchInitiator = new ValueStore<Key>();
    private readonly homeSensorsSearchInitiator = new ValueStore<Key>();
    private readonly homeSensorsDataValueStore = new ValueStore<Key>();
    private readonly categorySearchInitiator = new ValueStore<Key>();
	private readonly selectedItemsStore = new SelectedItemsStore(this.homeSensorsExcessesListStore, EntityType.SensorExcess);
	private readonly toDeleteItemsStore = new DeleteObjectsStore(EntityType.SensorExcess);

    readonly markup: JSX.Element;
    readonly homeLoadDashboardCmd: LoadDashboardCommand;
    readonly homeSearchVehicleCmd: SearchWithInitiatorCommand;
    readonly homeSearchSensorsCmd: SearchWithInitiatorCommand;
    readonly vehicleCategorySearch: SearchWithInitiatorCommand;

    constructor(polyglot: Polyglot, runSearch: SearchFn, getDashboard: DashboardFn, takeOverSensorExcess: TakeOverSensorExcessFn, getSensorsDataForIncident: GetSensorsDataForIncidentFn, getCurrentDivisionId: () => number, googleMapLoader: GoogleMapLoader, deleteObjects: DeleteObjectsFn)
    {
        this.homeLoadDashboardCmd = new LoadDashboardCommand(polyglot, getDashboard, getCurrentDivisionId, this.homeSensorsExcessesListStore.token, this.homeReportListStore.token, this.homeReportTableTitleStore.dispatchToken, null, null);
        const homeTakeOverSensorExcessCmd = new TakeOverSensorExcessCommand(takeOverSensorExcess, this.homeSensorsExcessesListStore.token, this.homeTakeOverSensorExcessInProgressStore.dispatchToken, this.homeTakeOverSensorExcessErrorStore.dispatchToken);
        const homeShowSensorsDataCmd = new ShowSensorsDataCommand(googleMapLoader, this.homeAlertStore.dispatchToken);
        this.homeSearchVehicleCmd = new SearchWithInitiatorCommand(polyglot, EntityType.Vehicle, runSearch, this.homeVehicleSearchInitiator.dispatchToken, this.homeExcessTableErrorStore.dispatchToken);
        this.homeSearchSensorsCmd = new SearchWithInitiatorCommand(polyglot, EntityType.Sensor, runSearch, this.homeSensorsSearchInitiator.dispatchToken, this.homeExcessTableErrorStore.dispatchToken);
        const homeFindIncidentDataCmd = new FindIncidentDataCommand(getSensorsDataForIncident, homeShowSensorsDataCmd, this.homeSensorsDataValueStore.dispatchToken, this.homeExcessTableErrorStore.dispatchToken);
        this.vehicleCategorySearch = new SearchWithInitiatorCommand(polyglot, EntityType.Vehicle, runSearch, this.categorySearchInitiator.dispatchToken, this.homeExcessTableErrorStore.dispatchToken);
        this.vehicleCategorySearch.addRequestMiddleware(getCurrentDivisionMiddleware(getCurrentDivisionId));
		const discardSensorExcessCommand = new DeleteObjectsCommand(EntityType.SensorExcess, this.toDeleteItemsStore, deleteObjects);

        this.markup = (
            <Dashboard polyglot={polyglot}
                assignCmd={homeTakeOverSensorExcessCmd}
                assignmentInProgressStore={this.homeTakeOverSensorExcessInProgressStore}
                assignmentErrorStore={this.homeTakeOverSensorExcessErrorStore}
                sensorsExcessesListStore={this.homeSensorsExcessesListStore}
				selectedItemsStore={this.selectedItemsStore}
                loadDashboardCmd={this.homeLoadDashboardCmd}
                reportTableTitleStore={this.homeReportTableTitleStore}
                reportListStore={this.homeReportListStore}
                sensorSearchCmd={this.homeSearchSensorsCmd}
                vehicleSearchCmd={this.homeSearchVehicleCmd}
                incidentDataSearchCmd={homeFindIncidentDataCmd}
                excessTableErrorStore={this.homeExcessTableErrorStore}
                alertStore={this.homeAlertStore}
                sensorsDataSearchInitiatorStore={this.homeSensorsDataValueStore}
                sensorsSearchInitiatorStore={this.homeSensorsSearchInitiator}
                vehicleSearchInitiatorStore={this.homeVehicleSearchInitiator}
                searchVehiclesByCategoryInitiator={this.categorySearchInitiator}
                searchVehiclesByCategory={this.vehicleCategorySearch}
                deleteObjectsStore={this.toDeleteItemsStore}
                deleteObjectsCommand={discardSensorExcessCommand}
            />
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/init/home.tsx